import useBulkMutate from '@/nebula/bulk-mutate';
import useRepo from '@/nebula/repo';
import { children as accountChildren } from '@/api/query/nebula/account';
import {
  account as accountConfig,
  accountSlug as accountSlugConfig,
} from 'shared/api/query/configs.json';
import { children as accountSlugChildren } from '@/api/query/nebula/account-slug';
import { isNullOrUndefined } from 'shared/lib/object/object';

export default function useAccountRepo() {
  const repo = useRepo(accountConfig.model);
  const bulkMutator = useBulkMutate();

  const updateSingle = (entity, options, hookParameter) => {
    if (!isNullOrUndefined(entity.activeSlug) && entity.activeSlug.uid === undefined) {
      entity.activeSlug.rid = 1;
      entity.activeSlug.account = { uid: entity.uid };
      const payloads = [
        {
          alias: 'createAccountSlug',
          model: accountSlugConfig.model,
          nodes: [entity.activeSlug],
          attributes: accountSlugChildren,
          createHookParameter: hookParameter,
        },
        {
          alias: 'updateAccount',
          nodes: [entity],
          model: accountConfig.model,
          attributes: accountChildren,
        },
      ];
      return bulkMutator.bulkMutate(payloads).then(() => repo.selectSingle(entity.uid));
    }
    return repo.updateSingle(entity, options, hookParameter);
  };

  return {
    ...repo,
    updateSingle,
  };
}
